import { Phone, Mail, MapPin, Clock, CalendarCheck } from "lucide-react";
import ContactForm from "@/components/ContactForm";
import { PageHero } from "@/pages/Agence";

export default function Contact() {
  return (
    <div data-testid="page-contact">
      <PageHero
        overline="Contact"
        title="Échangeons sur votre projet."
        subtitle="Une question, un devis, une mission d'expertise : nous vous répondons sous 48 heures ouvrées."
      />

      <section className="py-16 sm:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-12 gap-16">
            <div className="lg:col-span-5 space-y-8">
              <Info icon={MapPin} label="Adresse" value={["34 rue Saint-Bruno", "13004 Marseille"]} />
              <Info icon={Phone} label="Téléphone" value={["06 87 45 32 31"]} />
              <Info icon={Mail} label="E-mail" value={["contact@cabinetgpi-immobilier.fr"]} />
              <Info
                icon={Clock}
                label="Accueil téléphonique"
                value={[
                  "Du lundi au vendredi",
                  "de 9h00 à 12h00 et de 14h00 à 17h00",
                ]}
              />
              <Info
                icon={CalendarCheck}
                label="Réception physique"
                value={[
                  "Uniquement sur prise de rendez-vous",
                  "par mail ou par téléphone",
                ]}
              />
            </div>
            <div className="lg:col-span-7">
              <ContactForm testIdPrefix="page-contact" />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

function Info({ icon: Icon, label, value }) {
  return (
    <div className="flex items-start gap-5">
      <div className="w-12 h-12 border border-[#B8935A] flex items-center justify-center shrink-0">
        <Icon size={18} className="text-[#B8935A]" />
      </div>
      <div>
        <div className="font-overline text-[#94A3B8] text-[10px]">{label}</div>
        <div className="mt-2 text-[#0F172A] space-y-1">
          {value.map((v) => (
            <div key={v}>{v}</div>
          ))}
        </div>
      </div>
    </div>
  );
}
